import { ILinkedWizardListItem } from "interfaces/Components/LinkedWizard/ILinkedWizardListItem";
import React, { useState, useEffect } from "react";
import { LinkedWizardList } from "./LinkedWizardList";
import { Row, Col } from "react-bootstrap";
import { ArrowRight, ArrowDown } from "react-bootstrap-icons"
import "./LinkedWizard.scss";

interface IWizardListDetails {
    uniqueName : string;
    items : Array<ILinkedWizardListItem>;
    disabled? : boolean;
    title : string;
    overlayText : string;
    validationMessage? : string;
};
export default IWizardListDetails;

interface ILinkedWizardProps {
    lists : Array<IWizardListDetails>;
    maxListHeight? : number;
    onChange : (keys : Array<string | undefined>) => void;
    alwaysShowOverlayOnLoad : boolean; // If false then the overlay will only show where the selected value is 'undefined'
    overlayDomino : boolean // Domino, previous selection will remove next overlay.
};

const LinkedWizard = ( {lists, maxListHeight, onChange, alwaysShowOverlayOnLoad, overlayDomino = false} : ILinkedWizardProps) => {
    
    const [uniqueNames, setUniqueNames] = useState<Array<string>>([]);
    const [selectedValues, setSelectedValues] = useState<Array<string | undefined>>([]);
    const [overlayShownValues, setOverlayShownValues] = useState<Array<boolean>>([]);
    const [selectedItemReferences, setSelectedItemReferences] = useState<Array<HTMLButtonElement | null>>([]);

    // Populates our default values
    useEffect(() => {
        let tempUniqueNames : Array<string> = [];
        let tempSelectedValues : Array<string | undefined> = [];
        let tempOverlayShownValues : Array<boolean> = [];
        let tempSelectedItemReferences : Array<HTMLButtonElement | null> = [];
        
        lists.forEach(list => {

            let overlayShown : boolean = true;

            if (!alwaysShowOverlayOnLoad) {
                overlayShown = !(list.items.findIndex(item => item.selected) > -1);
            }

            tempUniqueNames.push(list.uniqueName);
            tempSelectedValues.push(list.items.find(item => item.selected)?.key);
            tempOverlayShownValues.push(overlayShown);
            tempSelectedItemReferences.push(null);

        });

        setUniqueNames(tempUniqueNames);
        setSelectedValues(tempSelectedValues);
        setOverlayShownValues(tempOverlayShownValues);
        setSelectedItemReferences(tempSelectedItemReferences);
    }, []);
    
    const onOverlayClicked = (uniqueName : string) => {
        const targetIndex : number = uniqueNames.findIndex(value => value === uniqueName);

        if (targetIndex > -1 && targetIndex < lists.length) {
            let newOverlayShownValues = [...overlayShownValues];
            newOverlayShownValues.splice(targetIndex, 1, false);
            setOverlayShownValues([...newOverlayShownValues]);
        }
    }

    const onAnyListChange = (uniqueName : string, key : string | undefined) => {

        const targetIndex : number = uniqueNames.findIndex(value => value === uniqueName);

        if (targetIndex > -1 && targetIndex < lists.length) {
            
            let newSelectedValues = [...selectedValues];
            newSelectedValues.splice(targetIndex, 1, key);
            setSelectedValues([...newSelectedValues]);
            checkOverlayBehaviour(targetIndex, overlayDomino);
            onChange([...newSelectedValues]);
        }
    }

    const onListShift = ( shift : number, uniqueName : string) => {
        const targetIndex : number = uniqueNames.findIndex(value => value === uniqueName);

        if (targetIndex > -1 && targetIndex < lists.length) {
            const newIndex : number = targetIndex + shift;
            
            if (newIndex >= 0 && newIndex < lists.length) {

                if (selectedItemReferences[newIndex]) {
                    selectedItemReferences[newIndex]?.focus();
                }
            }
        }
    };

    const onTargetReferenceChange = (uniqueName :string, elementReference : HTMLButtonElement | null) => {
        const targetIndex : number = uniqueNames.findIndex(value => value === uniqueName);

        if (targetIndex > -1 && targetIndex < lists.length) {
            selectedItemReferences.splice(targetIndex, 1, elementReference);
        }
    }

    const checkOverlayBehaviour = (index : number, behaviour : boolean) => {
        if (behaviour && ((index + 1) < lists.length)){
            const name = uniqueNames[index + 1]; 
            onOverlayClicked(name);
        }
    }

    return <>
        <Row className="d-flex">
            {   
                React.Children.toArray(
                    lists.map((list, index) => {
                        return <><Col className="list-block-container mb-1" xs={12} sm={6} md={3}>
                            <Row>
                                <Col className="mb-1">
                                    <LinkedWizardList
                                        key={list.uniqueName}
                                        uniqueName={list.uniqueName}
                                        items={list.items}
                                        onChange={onAnyListChange}
                                        onListShift={onListShift}
                                        title={list.title}
                                        disabled={list.disabled}
                                        overlayShown={overlayShownValues[index]}
                                        overlayText={list.overlayText}
                                        onOverlayClicked={onOverlayClicked}
                                        maxHeight={maxListHeight}
                                        validationMessage={list.validationMessage}
                                        onTargetReferenceChange={onTargetReferenceChange}/>
                                </Col>
                                {index < (lists.length-1) && <Col className="align-items-center p-0 d-none d-sm-flex" sm="auto"><ArrowRight size={38}/></Col>}
                                {index === (lists.length-1) && <Col className="align-items-center p-0 invisible" sm="auto"><ArrowRight size={38}/></Col>}
                            </Row>
                            <Row>
                                {index < (lists.length-1) && <Col className="mb-1 d-flex justify-content-center p-0 d-sm-none" xs={12}><ArrowDown size={38}/></Col>}
                            </Row>
                        </Col>
                            
                        </>
                    })
                )
            }

        </Row>
    </>;
}

export { LinkedWizard, IWizardListDetails };